var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-resolver',[_c('cad-monitoring-admin',{attrs:{"slot":"adminView"},slot:"adminView"}),_c('cad-monitoring-client',{attrs:{"slot":"clientView"},slot:"clientView"}),_c('cad-monitoring-public',{attrs:{"slot":"publicView"},slot:"publicView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }